import PropTypes from "prop-types";

import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import FeaturedClips from "components/FeaturedClips";
import SearchBoxGeneric from "components/SearchBoxGeneric";
import SearchResults from "components/SearchResults";

const AlgoliaFeaturedClips = ({ algoliaCard, initialQueryObject }) => {
  const title = AlgoliaCardsPresenter.title(algoliaCard);

  return (
    <SearchBoxGeneric
      initialQueryObject={initialQueryObject}
      searchResultsSkeletonSlot={<FeaturedClips loading />}
      resultsSlot={SearchResults}
      resultsSlotProps={{
        WrappedComponent: FeaturedClips,
        title,
        titleVariant: "h1",
      }}
    />
  );
};

AlgoliaFeaturedClips.propTypes = {
  algoliaCard: PropTypes.shape(),
  initialQueryObject: PropTypes.shape(),
};

export default AlgoliaFeaturedClips;
